import {Radio, Space} from 'antd';
import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledTransactionMatchingPanel = styled.div`
  ${bordersStyles.default};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 16px 24px;
`;

const StyledTransactionMatchingPanelActions = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  width: 100%;

  .ant-btn-link {
    align-items: center;
    color: ${props => props.theme.colors.primary_6};
    display: flex;
    padding: 0;
  }
`;

const StyledTransactionMatchingPanelContent = styled(StyledTransactionMatchingPanel)`
  padding: 12px;

  & > div {
    &:not(.ReactCollapse--collapse) {
      margin-bottom: 16px;
    }
  }
`;

const StyledTransactionMatchingPanelAmountSpace = styled(Space)`
  width: 118px;

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    color: ${props => props.theme.colors.neutral_7};
    font-size: 18px;
    line-height: 18px;
    padding-inline-start: 0;
    padding-inline-end: 0;
    width: 32px;
  }

  .ant-input-affix-wrapper {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right-color: transparent;

    &.ant-input-affix-wrapper-focused,
    &:active,
    &:focus,
    &:hover {
      border-right-color: #1688AE;
    }
  }

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right-color: transparent;

    &:active,
    &:focus,
    &:hover {
      border-right-color: #1688AE;
    }
  }
`;

const StyledTransactionMatchingPanelHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  .ant-btn {
    color: ${props => props.theme.colors.neutral_7};

    .anticon-close {
      font-size: 12px;
    }
  }
`;

const StyledTransactionMatchingPanelHeaderTitle = styled.div`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};

  display: inline-block;
`;

const StyledTransactionMatchingPanelFilterSpace = styled(Space)`
  margin-bottom: 16px;

  .ant-input-suffix,
  .ant-space-compact-block .ant-btn {
    color: ${props => props.theme.colors.neutral_7};
  }

  .ant-space-compact-block {
    .ant-btn {
      &:nth-of-type(1) {
        &:hover,&:focus,&:active {
          border-color: ${props => props.theme.colors.status_grey};
          box-shadow: unset;
          color: ${props => props.theme.colors.neutral_7};
          cursor: unset;
        }
      }
      &:nth-of-type(2) {
        align-items: center;
        display: flex;
        font-size: 18px;
        justify-content: center;
      }
    }
  }
`;

const StyledTransactionMatchingPanelRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  min-height: 118px;
  max-height: 300px;
  overflow: auto;

  & > label {
    ${bordersStyles.default};

    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    padding: 12px 24px;
    margin: 0;

    span.ant-radio+* {
      padding-inline-start: 0;
      padding-inline-end: 0;
    }

    &:not(:last-of-type) {
      margin-bottom: 12px;
    }

    & > span:not(.ant-radio) {
      width: 100%;
    }
  }
`;

const StyledTransactionMatchingPanelTransactionsContainer = styled.div`
`;

export {
  StyledTransactionMatchingPanel,
  StyledTransactionMatchingPanelActions,
  StyledTransactionMatchingPanelContent,
  StyledTransactionMatchingPanelAmountSpace,
  StyledTransactionMatchingPanelHeader,
  StyledTransactionMatchingPanelHeaderTitle,
  StyledTransactionMatchingPanelFilterSpace,
  StyledTransactionMatchingPanelRadioGroup,
  StyledTransactionMatchingPanelTransactionsContainer,
}
